import { FC, useState } from 'react';
import { Chart } from 'react-google-charts';
import styled from 'styled-components';

import { MAPS_API_KEY, REGIONS_OPTIONS, STARTING_REGION } from 'constants/googleMaps';
import { BasicSelect } from 'ui/selects';

import { useProfileQueryContext } from './contexts';
import { InsightPanel } from './InsightPanel';
import { AUD_INSIGHTS_GRID_COL_COUNT } from './constants';
import { AudienceCount } from '../domain';
import { useTranslation } from '../hooks';

const MapWrapper = styled.div`
  padding: 0 ${({ theme }) => theme.spacing.values.base};
`;

const SelectWrapper = styled.div`
  width: ${({ theme }) => theme.spacing.values.x24};
  margin-bottom: ${({ theme }) => theme.spacing.values.base};
  margin-left: -${({ theme }) => theme.spacing.values.base};
`;

const convertCountsToMapData = (locations: AudienceCount[]) => {
  const header = [['City', 'Activity', { role: 'tooltip', type: 'string' }]];

  return header.concat(
    locations.map((location) => [location.name, `${location.count}`, location.name]),
  );
};

export const LocationsMap: FC = () => {
  const { t } = useTranslation();
  const { locations } = useProfileQueryContext();
  const [region, setRegion] = useState(STARTING_REGION);
  const values = locations ?? [];

  return (
    <InsightPanel colSpan={AUD_INSIGHTS_GRID_COL_COUNT} title={t('insights.locations')}>
      <MapWrapper data-test="locations-map">
        <SelectWrapper>
          <BasicSelect
            onSelect={setRegion}
            defaultValues={region}
            placeholder="Select a location..."
            id="location-region"
            options={REGIONS_OPTIONS}
            title="location"
          />
        </SelectWrapper>
        <Chart
          width="100%"
          height="auto"
          chartType="GeoChart"
          data={convertCountsToMapData(values)}
          options={{
            region: region[0],
            displayMode: 'markers',
            colors: ['#3498db', '#e74c3c'],
          }}
          mapsApiKey={MAPS_API_KEY}
        />
      </MapWrapper>
    </InsightPanel>
  );
};
